import { System } from '@ecs/System';
import { RailgunWeapon } from '@components/RailgunWeapon';
import { ChargeEffectRequest } from '@components/ChargeEffectRequest';
import { AimTelegraph } from '@components/AimTelegraph';
import { Position } from '@components/Position';

export class RailgunChargeLogicSystem extends System {
  update(_deltaTime: number): void {
    // Process all entities with railgun weapons
    const entities = this.getEntitiesWithComponents(RailgunWeapon, Position);
    
    for (const entity of entities) {
      const railgun = entity.getComponent(RailgunWeapon)!;
      const position = entity.getComponent(Position)!;
      const telegraph = entity.getComponent(AimTelegraph);
      const charging = railgun.isCharging && railgun.chargeStartTime > 0;

      if (telegraph) {
        telegraph.active = charging;
      }

      if (!charging) continue;

      const chargeProgress = Math.min(
        (Date.now() - railgun.chargeStartTime) / railgun.chargeTime,
        1
      );

      // Warn the player where the shot will go
      if (telegraph) {
        telegraph.angle = railgun.aimAngle;
        telegraph.length = railgun.range;
        telegraph.progress = chargeProgress;
        telegraph.color = railgun.bulletColor;
      }
        
      // Create charge effect request
      if (chargeProgress > 0.1) { // Start showing effect after 10% charge
        entity.addComponent(new ChargeEffectRequest(
          position.x,
          position.y,
          railgun.aimAngle,
          chargeProgress,
          Math.floor(3 + chargeProgress * 2), // 3-5 particles based on charge
          railgun.bulletColor
        ));
      }
    }
  }
}
